// extracted by mini-css-extract-plugin
export default {"primary":"C1GoW52rolPuYMex0qZJ","secondary":"HNtQYBoaxsUx_FZyP2tS"};